import { lazyImport } from "../../utility/lazyImport";


const { Request } = lazyImport(
    () => import("../../features/requestCooperation"),
    "Request"
);

const { Requests } = lazyImport(
    () => import("../../features/requestCooperation"),
    "Requests"
);

const { RequestDetails } = lazyImport(
    () => import("../../features/requestCooperation"),
    "RequestDetails"
);

const RequestCooperationRoutes = [
    {
        path: "/request",
        element: <Request />,
        meta: {
            action: "create",
            resource: "request",
        },
    },
    {
        path: "/requests",
        element: <Requests />,
        meta: {
            action: "read",
            resource: "request",
        },
    },
    {
        path: "/requests/:id",
        element: <RequestDetails />,
        meta: {
            action: "read",
            resource: "request",
        },
    },
];

export default RequestCooperationRoutes;
